import { Navigate } from "react-router-dom";
import useAuth from "../auth/useAuth";
import tokenService from "../auth/tokenService";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex h-screen items-center justify-center">
      <span>Loading...</span>
    </div>;
  }

  if (!user || !tokenService.hasRefreshToken()){
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;